__turbopack_context__.v({
  "quizContent": "styles-module__Mna7NG__quizContent",
  "quizDescription": "styles-module__Mna7NG__quizDescription",
  "quizEntryPoint": "styles-module__Mna7NG__quizEntryPoint",
  "quizModal": "styles-module__Mna7NG__quizModal",
  "selectionContainer": "styles-module__Mna7NG__selectionContainer",
});
